import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQueryStringResults } from '@plone/volto/actions';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';

const PreFooter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getQueryStringResults(
        '',
        {
          limit: 3,
          query: [
            {
              i: 'Subject',
              o: 'plone.app.querystring.operation.selection.any',
              v: ['campaign-ask'],
            },
          ],
        },
        'footer-news',
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const news = useSelector(
    (state) => state.querystringsearch.subrequests['footer-news'],
  );

  const Image = config.getComponent('Image').component;

  return (
    <div className="footer-top">
      {news?.items?.map((item) => (
        <div key={item['@id']} className="footer-item">
          <UniversalLink href={item['@id']}>
            <Image
              className="preview-image"
              src={`${item['@id']}/${item.image_scales.preview_image[0].scales.preview.download}`}
              alt=""
              loading="lazy"
              responsive={true}
            />
            <div className="content">
              {item.head_title && (
                <div className="headline">{item.head_title}</div>
              )}
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </UniversalLink>
        </div>
      ))}
    </div>
  );
};

export default PreFooter;
